import { setFullTextDocumentIdType } from './HopintoConstants';

// eslint-disable-next-line import/prefer-default-export
export function setFullTextDocumentId(payload) {
  return {
    type: setFullTextDocumentIdType,
    payload,
  };
}
